// @ts-check
import styled from 'styled-components';
import { HeaderMenuSpacer } from './LinkItem';

const HeaderMenu = styled.div`
  position: relative;
  display: flex;
  padding: 0 10px 5px;
  justify-content: space-between;
  min-width: 100%;
  margin-top: ${({ theme }) => (theme.name === 'brightworld' ? '20px' : '10px')};

  > div {
    margin-right: 0;

    &:last-child {
      margin-right: 0;
    }
  }

  ${HeaderMenuSpacer} {
    display: none;
  }

  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    padding: 10px 0;

    .header-aside {
      display: flex;
    }

    > div {
      margin-right: 30px;
    }

    ${HeaderMenuSpacer} {
      display: block;
      margin-right: 0;
    }
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    min-width: auto;
    padding: 0 10px;

    > div {
      margin-right: 40px;
    }

    .header-aside,
    ${HeaderMenuSpacer} {
      display: none;
    }

    ${HeaderMenuSpacer} {
      margin-right: 0;
    }
  }
`;

export default HeaderMenu;
